import { createSlice } from '@reduxjs/toolkit';
import { createCreateTeamReducer, createDeleteTeamReducer, createEditTeamReducer } from 'modules/teams/store/teams/reducers';

/**
 * Слайс мутаций команд: создание, правка, удаление.
 *
 * Списка здесь больше нет. Раньше слайс копил все загруженные команды, а страница
 * `/teams` резала этот массив на страницы клиентом; теперь перечень живёт в RTK
 * Query (`teamsApi.listTeams`), а мутации сбрасывают его тегом (см. `actions.ts`).
 */
export interface TeamsSliceState {
  error?: any;

  processing: boolean;
  processedName?: string;
}

const initialState: TeamsSliceState = {
  processing: false,
};

export const teamsSlice = createSlice({
  name: 'teams/teams',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    createCreateTeamReducer(builder);
    createEditTeamReducer(builder);
    createDeleteTeamReducer(builder);
  },
});

export const { resetError } = teamsSlice.actions;

export default teamsSlice.reducer;
